import { getProxySessionToken } from '../config/proxySessionToken';

/**
 * Zapis do Supabase przez supabase-proxy.php (service role po stronie serwera).
 * Używane m.in. gdy panel działa w trybie bezpośrednim, ale trzeba zapisać ustawienie w bazie.
 */
export async function upsertAppSettingViaProxy(settingKey, settingValue) {
  const proxyUrl = (process.env.REACT_APP_SUPABASE_PROXY_URL || '').trim().replace(/\/$/, '');
  const proxyToken = getProxySessionToken();
  if (!proxyUrl || !proxyToken) {
    return { error: new Error('Brak REACT_APP_SUPABASE_PROXY_URL lub sesji admina (zaloguj się)') };
  }

  const pathWithQuery = '/rest/v1/app_settings?on_conflict=setting_key';
  const body = JSON.stringify([
    {
      setting_key: settingKey,
      setting_value: settingValue,
      updated_at: new Date().toISOString(),
    },
  ]);

  try {
    const response = await fetch(proxyUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Proxy-Token': proxyToken,
        'X-Supabase-Path': pathWithQuery,
        Prefer: 'resolution=merge-duplicates',
      },
      body,
    });

    if (!response.ok) {
      const text = await response.text();
      return {
        error: new Error(
          text ? `Proxy HTTP ${response.status}: ${text.slice(0, 200)}` : `Proxy HTTP ${response.status}`
        ),
      };
    }
    return { error: null };
  } catch (err) {
    return { error: err };
  }
}
